import styled from "styled-components";

export const StartAdornment = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
`;
